import { render, staticRenderFns } from "./CustomerReceiveList.vue?vue&type=template&id=52b3b52e&scoped=true"
import script from "./CustomerReceiveList.vue?vue&type=script&lang=js"
export * from "./CustomerReceiveList.vue?vue&type=script&lang=js"
import style0 from "./CustomerReceiveList.vue?vue&type=style&index=0&id=52b3b52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3b52e",
  null
  
)

export default component.exports